export const ACCOUNTS_CARD_TAG_NAME = 'tm-bo-accounts-card';
export const ACCOUNTS_TABLE_TAG_NAME = 'tm-bo-accounts-table';
export const ACCOUNT_DETAIL_TAG_NAME = 'tm-bo-account-detail';
